import React, { useContext } from 'react';
import PrimarySizeTiles from './PrimarySizeTiles';
import SecondarySizeTiles from './SecondarySizeTiles';
import ProductPageContext from '../../contexts/ProductPageContext';
import UrgencyMessage from '../UrgencyMessage/UrgencyMessage';
import ShopSimilar from '../ShopSimilar/ShopSimilar';
import HighlightedTextWrapper from '../HighlightedTextWrapper/HighlightedTextWrapper';

export default function SizeTileSection(
  {
    primarySizeTileHandler,
    secondarySizeTileHandler,
    setSizeGuideOpen,
  },
) {
  const ProductPageState = useContext(ProductPageContext);

  const {
    tmntData,
    collectionData,
    content,
    type,
    featureFlags,
  } = ProductPageState;

  const {
    primarySizeArray,
    secondarySizeArray,
    sizeTileAttrs,
    primarySizeGroupHeading,
    secondarySizeGroupHeading,
    activeProduct,
  } = collectionData;

  if (!activeProduct) {
    return null;
  }

  const handleSkuUrgencyMessage = () => {
    const { skuUrgency } = collectionData;
    if (skuUrgency === 'backordered') {
      return tmntData?.backorderUrgencyMessage.value;
    }
    return tmntData?.sizeUrgencyMessage?.value.replace('{0}', collectionData.skuUrgency);
  };

  return (
    <>
      <PrimarySizeTiles
        primarySizeArray={primarySizeArray}
        primarySizeTileHandler={primarySizeTileHandler}
        primaryTileSize={sizeTileAttrs?.primaryTileSize}
        primarySizeGroupHeading={primarySizeGroupHeading}
        activeProduct={activeProduct}
        tmntData={tmntData}
        setSizeGuideOpen={setSizeGuideOpen}
      />

      {(type !== 'exchange' && featureFlags?.['pdp-shop-similar']) ? (
        <HighlightedTextWrapper>
          {!ProductPageState?.collectionData?.isEyewearProduct && (
          <ShopSimilar
            collectionData={collectionData}
            cta={ProductPageState.tmntData?.shopSimilarCta?.value}
            label={ProductPageState.tmntData?.shopSimilarLabel?.value}
          />
          )}
        </HighlightedTextWrapper>
      ) : ''}

      <SecondarySizeTiles
        secondarySizeArray={secondarySizeArray}
        secondarySizeTileHandler={secondarySizeTileHandler}
        secondaryTileSize={sizeTileAttrs?.secondaryTileSize}
        secondarySizeGroupHeading={secondarySizeGroupHeading}
        eSpotContent={content?.pdpESpots}
        tmntData={tmntData}
      />
      <UrgencyMessage
        urgencyMessage={handleSkuUrgencyMessage()}
        showUrgencyMessage={collectionData.skuUrgency}
        rerenderKey={handleSkuUrgencyMessage()}
      />
    </>
  );
}
